import BreadCrumbComponent from "../components/Items/BreadCrumb/Index";
import SinglePackageComponent from "../components/packages/SinglePackageComponent";

const SinglePackagePage = () => {
  return (
    <>
      <BreadCrumbComponent
        lastItem="Package Details"
        routes={[
          { title: "Home", path: "/" },
          { title: "Packages", path: "/packages" },
        ]}
      />
      <SinglePackageComponent />
    </>
  );
};
export default SinglePackagePage;
